import React from "react";
import styles from "./button.module.scss";
import LocalizedLink from "@components/LocalizedLink/localizedLink";

const Button = ({ href, text, locale, className }) => (
  <LocalizedLink to={href} locale={locale} className={`${styles.button} ${className}`}>{text}</LocalizedLink>
)

export default Button;
